import { render, staticRenderFns } from "./SCH.vue?vue&type=template&id=7a660490&"
import script from "./SCH.vue?vue&type=script&lang=js&"
export * from "./SCH.vue?vue&type=script&lang=js&"
import style0 from "./SCH.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a660490')) {
      api.createRecord('7a660490', component.options)
    } else {
      api.reload('7a660490', component.options)
    }
    module.hot.accept("./SCH.vue?vue&type=template&id=7a660490&", function () {
      api.rerender('7a660490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61980520-8/SCH.vue"
export default component.exports